import { render, staticRenderFns } from "./ManageClientDatabases.vue?vue&type=template&id=1b79581d&"
import script from "./ManageClientDatabases.vue?vue&type=script&lang=js&"
export * from "./ManageClientDatabases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports